import capitaliseFirstLetter from './capitaliseFirstLetter'

// Ensure narrative text starts with a letter, then apply existing first-letter capitalisation.
export default function normaliseLeadingLetterText(value) {
  const text = typeof value === 'string' ? value : ''
  return capitaliseFirstLetter(text.replace(/^[^A-Za-z]+/, ''))
}
